import { oz } from '@weft/utils';
import { CommercialTermsPricingConfigurationSchema } from './commercial-terms/commercial-terms-pricing-configuration-schema';
import { CommissionPricingConfigurationSchema } from './fixed-commission/commission-pricing-configuration-schema';
import { OneTimePricingConfigurationSchema } from './fixed-one-time/one-time-pricing-configuration-schema';
import { FixedPerUnitPricingConfigurationSchema } from './fixed-per-unit/fixed-per-unit-pricing-configuration-schema';
import { InstallmentsPricingConfigurationSchema } from './installments/installments-pricing-configuration-schema';
import { RefundPricingConfigurationSchema } from './refund';
import { SubscriptionPricingConfigurationSchema } from './subscription/subscription-pricing-configuration-schema';

export const FixedPricingConfigurationSchema = oz.union([
  OneTimePricingConfigurationSchema,
  FixedPerUnitPricingConfigurationSchema,
  SubscriptionPricingConfigurationSchema,
  CommercialTermsPricingConfigurationSchema,
  CommissionPricingConfigurationSchema,
  InstallmentsPricingConfigurationSchema,
  RefundPricingConfigurationSchema,
]).openapi('FixedPricingConfiguration');

export type FixedPricingConfiguration = oz.infer<typeof FixedPricingConfigurationSchema>;